import { useState } from "react";
export var useModal = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(""), message = _b[0], setMessage = _b[1];
    var _c = useState(null), action = _c[0], setAction = _c[1];
    var openModal = function (msg, action) {
        setMessage(msg);
        if (action)
            setAction(function () { return action; });
        setIsOpen(true);
    };
    var closeModal = function () {
        setIsOpen(false);
    };
    return { isOpen: isOpen, message: message, action: action, openModal: openModal, closeModal: closeModal };
};
